import * as RadixAvatar from '@radix-ui/react-avatar';
import * as React from 'react';
import { cn } from '../utils/cn';

export interface AvatarProps extends React.ComponentPropsWithoutRef<typeof RadixAvatar.Root> {
  src?: string | null;
  alt?: string;
  fallback?: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizes: Record<NonNullable<AvatarProps['size']>, string> = {
  sm: 'size-8 text-xs',
  md: 'size-10 text-sm',
  lg: 'size-12 text-base',
};

export const Avatar = React.forwardRef<React.ElementRef<typeof RadixAvatar.Root>, AvatarProps>(
  ({ src, alt, fallback, size = 'md', className, ...props }, ref) => {
    const initials = (fallback ?? alt ?? '?').slice(0, 2).toUpperCase();
    return (
      <RadixAvatar.Root
        ref={ref}
        className={cn(
          'relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full',
          'bg-brand-100 font-semibold text-brand-700',
          sizes[size],
          className,
        )}
        {...props}
      >
        {src ? (
          <RadixAvatar.Image src={src} alt={alt ?? ''} className="size-full object-cover" />
        ) : null}
        <RadixAvatar.Fallback delayMs={400}>{initials}</RadixAvatar.Fallback>
      </RadixAvatar.Root>
    );
  },
);
Avatar.displayName = 'Avatar';
